export default "__VITE_ASSET__CLxfeb6N__"